/**
 * Jambuveda Ingredients page — filters + detail modal.
 * All 32+ ingredients are rendered server-side by Liquid; this file just
 * handles (1) filter chip show/hide and (2) opening/closing the detail
 * panel when a card is clicked, reading its data-* attributes.
 */
(function () {
  const filters = document.getElementById('jv-ing-filters');
  const grid = document.getElementById('jv-ing-grid');
  const overlay = document.getElementById('jv-ing-overlay');
  const closeBtn = document.getElementById('jv-ing-close');

  // ---- Filter chips ----
  if (filters && grid) {
    const chips = filters.querySelectorAll('.jv-chip');
    const cards = grid.querySelectorAll('.jv-ing__card');

    filters.addEventListener('click', (e) => {
      const btn = e.target.closest('.jv-chip');
      if (!btn) return;
      const filter = btn.dataset.filter;

      chips.forEach((c) => c.classList.toggle('is-active', c === btn));

      let visibleCount = 0;
      cards.forEach((card) => {
        const match = filter === 'all' || card.dataset.concern === filter;
        card.classList.toggle('jv-hidden', !match);
        if (match) visibleCount += 1;
      });

      const existingEmpty = grid.querySelector('.jv-ing__empty');
      if (existingEmpty) existingEmpty.remove();

      if (visibleCount === 0) {
        const empty = document.createElement('div');
        empty.className = 'jv-ing__empty';
        empty.textContent = 'No ingredients tagged for this concern yet.';
        grid.appendChild(empty);
      }
    });
  }

  // ---- Detail modal: open on card click ----
  if (grid && overlay) {
    grid.addEventListener('click', (e) => {
      const card = e.target.closest('.jv-ing__card');
      if (!card) return;
      openPanel(card);
    });
  }

  function openPanel(card) {
    const d = card.dataset;

    setText('jv-ing-panel-hi', d.hi);
    setText('jv-ing-panel-name', d.name);
    setText('jv-ing-panel-botanical', d.botanical);
    setText('jv-ing-panel-desc', d.desc);
    setText('jv-ing-panel-rasa', d.rasa);
    setText('jv-ing-panel-virya', d.virya);
    setText('jv-ing-panel-origin', d.origin);
    setText('jv-ing-panel-part', d.part);

    // Products — render as a labeled list, same "Used in" pattern as the card
    const productsEl = document.getElementById('jv-ing-panel-products');
    if (productsEl) {
      if (d.products) {
        const names = d.products.split(',').map((s) => s.trim()).filter(Boolean);
        productsEl.innerHTML =
          '<span class="jv-ing__panel-products-label">Used in</span> ' +
          names.map((n) => `<span class="jv-ing__product-pill">${escapeHtml(n)}</span>`).join(' ');
      } else {
        productsEl.innerHTML = '';
      }
    }

    // Photo or icon placeholder
    const photoEl = document.getElementById('jv-ing-panel-photo');
    if (photoEl) {
      if (d.img) {
        photoEl.innerHTML = `<img src="${escapeHtml(d.img)}" alt="${escapeHtml(d.name || '')}" loading="lazy">`;
      } else {
        photoEl.innerHTML = '';
      }
    }

    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  function setText(id, value) {
    const el = document.getElementById(id);
    if (el) el.textContent = value || '';
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closePanel();
    });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay && !overlay.hidden) closePanel();
  });
})();
